import coreAPI from 'apis/core';

export const getAllAnnouncements = async (params) => {
  const response = await coreAPI.announcement.getAll(params);

  return {
    announcements: response.data || [],
    pagination: response.pagination || {},
  };
};

export default {};
